import { IAgentDetail } from "@vahak/core/dist/custom-types/common-preloads";

export const checkTsoTagged = (tso: IAgentDetail = {}) => {
    const user_id = tso?.user_id ?? 1;
    return user_id > 1;
};
